import { useCallback } from 'react'
import { useThemeContext, type Theme, type ResolvedTheme } from '@/lib/theme'

export type { Theme, ResolvedTheme }

/**
 * Convenience hook — wraps the ThemeContext and adds a legacy `toggleTheme`
 * for components that just want a binary dark/light flip.
 */
export function useTheme() {
  const { theme, resolvedTheme, setTheme } = useThemeContext()

  /** Toggle between dark and light (bypasses system). */
  const toggleTheme = useCallback(() => {
    setTheme(resolvedTheme === 'dark' ? 'light' : 'dark')
  }, [resolvedTheme, setTheme])

  return { theme, resolvedTheme, setTheme, toggleTheme }
}
